import React from 'react';

import Button from '@material-ui/core/Button';
import cx from 'classnames';

import useStyles from './styles';

interface IconButtonProps {
  btnClass?: string;
  label?: string;
  icon: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  label,
  btnClass,
  onClick,
  disabled = false,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Button
      disabled={disabled}
      className={cx(classes.button, btnClass)}
      onClick={onClick}
      {...rest}
    >
      {icon}
      <span className={classes.buttonLabel}>{label}</span>
    </Button>
  );
};

export default IconButton;
